import { useId, type ReactNode, type SelectHTMLAttributes } from "react";

/** Rótulo + `<select>` com a mesma moldura dos campos de texto. */
export function Selecionar({
  rotulo,
  children,
  className,
  ...resto
}: { rotulo: string; children: ReactNode } & Omit<SelectHTMLAttributes<HTMLSelectElement>, "id">) {
  const id = useId();
  return (
    <div className={`campo ${className ?? ""}`}>
      <label className="campo__rotulo" htmlFor={id}>
        {rotulo}
      </label>
      <select id={id} className="campo__controle" {...resto}>
        {children}
      </select>
    </div>
  );
}
